var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStudiesinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 30a1.667 1.667 0 001.667-1.667V15.274a1.666 1.666 0 00-.488-1.179l-3.608-3.607A1.667 1.667 0 0023.061 10h-9.729a1.667 1.667 0 00-1.667 1.667v16.666A1.666 1.666 0 0013.332 30h13.336zm-2.084-5a.625.625 0 01-.625.625h-8.127a.625.625 0 110-1.25h8.127a.625.625 0 01.625.625zm-9.146-3.492l2.722-2.721a.833.833 0 011.019-.126l1.386.833a.21.21 0 00.25-.032L22.9 17.38a.836.836 0 111.185 1.18l-2.657 2.655a.834.834 0 01-1.018.125l-1.387-.833a.208.208 0 00-.25.03l-2.155 2.15a.834.834 0 01-1.179-1.178z",
    fill: "#0F0449"
  })));
}

export default SvgStudiesinline;